import React, { useState, useEffect, Fragment } from "react";
// import PropTypes from "prop-types";
import { connect } from "react-redux";
import classnames from "classnames";
import { projectNamesOnly } from "../../datas/projects";
import SelectBoxSearch from "../common/SelectBoxSearch";

import {
  getEmployeeWorkingProjects,
  getTaskProjectId,
  addProjectFromTask,
  getAllTaskOfProject,
} from "../../redux/actions/task/task.action";
import { getLoginUser } from "../../redux/actions/loginAuth/LoginAuth";

import { getProjectsOfEmployee,getProjectsOfAdmin } from "../../redux/actions/projects/projects.action";

const TaskSideBar = (props) => {
  const {
    getEmployeeWorkingProjects,
    getTaskProjectId,
    getProjectsOfEmployee,
    getProjectsOfAdmin,
    addProjectFromTask,
    getLoginUser,
    getSelectProject,
    getAllTaskOfProject,
  } = props;
  const { projectNames } = props.empTask;
  const { login, loginUser, loginInput } = props.loginUser;

  const { employeeProjectList } = props.employeeProjectList;
  const [activeProject, setActiveProject] = useState(0);
  const [projectName, setProjectName] = useState("");
  const [backToHome, setBackToHome] = useState("");

  const [modal, setModal] = useState(false);

  const toggle = React.useCallback(
    () => setModal((prevState) => !prevState),
    []
  );
  useEffect(() => {
    var loginUser = JSON.parse(localStorage.getItem("user"));
    let empId = loginUser.EmployeeId;
    if(loginUser.RoleName === "Admin")
    {
      getProjectsOfAdmin(empId);
    }
    else
    {
      getProjectsOfEmployee(empId);
    }
   
    getEmployeeWorkingProjects(empId);
  }, [getEmployeeWorkingProjects, getProjectsOfEmployee]);
  const [searchArr, setSearchArr] = useState([]);
  let ss=[];
  const filtertask = React.useCallback(() =>
  {
    employeeProjectList.map((ListOfProjects, i) => {
      let filterOnlyActiveProject = ListOfProjects.projectList.filter(
        (el) => el.activeStatus === true
      );
      filterOnlyActiveProject.map((el) =>{
       ss.push(el);
      })
      
 
      setSearchArr(ss.filter( (ele, ind) => ind === ss.findIndex( elem => elem.projectID === ele.projectID)));
    });
  },[employeeProjectList])
  useEffect(() => {
    // console.log(employeeProjectList);
     // take not deleted projects, ie activeStatus === true.
     employeeProjectList.map((ListOfProjects, i) => {
    //  let filterOnlyActiveProject = ListOfProjects.projectList.filter(
    //    (el) => el.activeStatus === true 
    //  );
     if(ss.length !==0)
     {
      // ss.map((newilis) =>{
      const itemexist=ss.some(item => item.projectID === ListOfProjects.projectID);
      var newilis=ss.find(item => item.projectID === ListOfProjects.projectID);

        if(newilis === undefined){
          ss.push(ListOfProjects);
        }
        else
        {
          if(newilis.projectID === ListOfProjects.projectID)
          {
            const indexs = ss.findIndex(prod => prod.projectID === ListOfProjects.projectID);
            if(newilis.status !== ListOfProjects.status && newilis.status === false)
            {
              ss.splice(indexs,1);
              ss.push(ListOfProjects);
            }
            
          }
          else
          {
            ss.push(ListOfProjects);
          }
        }
       
     
      //  })
     }
     else
     {
      ss.push(ListOfProjects);
     }
    
    //  const itemexist=ss.some(item => item.projectID === ListOfProjects.projectID);
    //   if(itemexist === false)
    //   {
    //     ss.push(ListOfProjects);
    //   }
    //  ListOfProjects.map((el) =>{
    //   const itemexist=ss.some(item => item.projectID === el.projectID);
    //   if(itemexist === false)
    //   {
    //     ss.push(el);
    //   }
     
    //  })
     

     setSearchArr(ss.filter( (ele, ind) => ind === ss.findIndex( elem => elem.projectID === ele.projectID)));
     })
   }, [employeeProjectList]);
  useEffect(() => {
    getLoginUser();
  }, []);

  useEffect(() => {
    if (loginUser !== null) {
      if (loginUser.RoleName === "Admin") {
        setBackToHome("/adminDashBoard");
      } else {
        setBackToHome("/employeeDashBoard");
      }
    }
  }, [loginUser]);

  //   Function .
  // click projects.
  const handleSelectProject = React.useCallback(
    (projectId, projectName,status, i) => {
      getTaskProjectId(projectId,projectName,status); // keep the selected project id in reducer to filter the task.
      setActiveProject(i);
     
      // getSelectProject(projectId);
      //  filtertask();
    },
    [getTaskProjectId,getEmployeeWorkingProjects]
  );

  // handle the project name from the selection.
  const handleGetProjectName = React.useCallback((projectName) => {
    setProjectName(projectName.value);
  }, []);

  // handle submite project name.
  const handleSubmitProjectName = React.useCallback(
    (e) => {
      e.preventDefault();
      addProjectFromTask(projectName);
      toggle();
    },
    [addProjectFromTask, projectName, toggle]
  );

  return (
    <Fragment>
      <ul className="list-unstyled components">
        <li className="">
          <a href={backToHome}>
            <i className="fas fa-home"></i>
            <span>Back Home</span>
          </a>
        </li>
        {/* <hr></hr> */}

        {/* <li className="">
          <a href={"#project"} onClick={toggle}>
            <i className="fa fa-plus"></i>
            <span>
              Project
              <i className="fas fa-plus float-right "></i>
            </span>
          </a>
        </li> */}
        
        {searchArr.map((ListOfprojects, i) =>(
          // ListOfprojects.map((projects) => (
            <li
              key={ListOfprojects.projectId+i}
              style={{ padding: "-10px" }}
              onClick={() =>
                handleSelectProject(ListOfprojects.projectID, ListOfprojects.projectName,ListOfprojects.status, i)
              }
              className={classnames({ active: (props.empTask?.taskProjectInfo?.projectId === ListOfprojects.projectID) || (!props.empTask?.taskProjectInfo?.projectId && activeProject === i) })}
            >
              <a href="#projectName">
                <span style={{ textTransform: "capitalize" }}>- {ListOfprojects.projectName}</span>
              </a>
            </li>
        )
          // ))
        )}
      </ul>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  empTask: state.taskReducer,
  employeeProjectList: state.projectReducer,
  loginUser: state.loginAuthReducer,
});

export default connect(mapStateToProps, {
  getEmployeeWorkingProjects,
  getProjectsOfEmployee,
  getProjectsOfAdmin,
  getTaskProjectId,
  getAllTaskOfProject,
  addProjectFromTask,
  getLoginUser,
})(TaskSideBar);
